import React from 'react';
import Modal from './Modal';
import { P3Configuration } from 'models/interfaces/P3Configurations';
import { ThomasAdvertiser } from 'models/interfaces/index';
import { Formik, Field } from 'formik';
import { Form } from 'react-bootstrap';
import { StackedText, StackedSelect } from '@tpco/blueprint-react';

interface P3TemplateAssignProps {
  isModalOpen: boolean;
  advertisers: any[];
  template: P3Configuration;
  onClose: () => void;
  onSaveAssign: (values: any) => void;
}

const P3TemplateAssign: React.FC<P3TemplateAssignProps> = ({
  isModalOpen,
  advertisers,
  template,
  onClose,
  onSaveAssign
}) => {
  // console.log('template to Assign: ', template);
  // console.log(`advertisers list modal`, advertisers);
  const nameValidation = (value: string) => {
    if (!value) {
      return 'Required';
    }

    return null;
  };

  const advertiserValidation = (value: string) => {
    if (!value) {
      return 'Required';
    }

    return null;
  };

  const composeSaveObject = (values: any) => {
    console.log(`assign values`, values);
    const saveObject: any = {
      p3_configuration_id: template.p3_configuration_id,
      tgrams_id: values.tgramsId,
      name: values.name
    };

    onSaveAssign(saveObject);
  };

  const initialValues = {
    name: template ? template.name : ''
  };

  return (
    <Modal
      onClose={onClose}
      isModalOpen={isModalOpen}
      el={document.createElement('div')}
      modalWidth="80%"
    >
      <Formik
        initialValues={initialValues}
        onSubmit={values => composeSaveObject(values)}
        enableReinitialize={false}
      >
        {({ handleSubmit, values }) => (
          <Form className="card edit-campaign__container" onSubmit={handleSubmit}>
            <h4 className="edit-campaign__title">Assign Template</h4>
            <StackedText
              className="form-group__col-flex-column saturn-form-group saturn-col saturn-flex-column"
              htmlId="edit-p3-name"
              fieldName="name"
              labelText="Name"
              validate={nameValidation}
            />
            <StackedSelect
              className="form-group__col-flex-column saturn-form-group saturn-col saturn-flex-column"
              htmlId="edit-campaign-template"
              fieldName="tgramsId"
              labelText="Accounts"
              options={advertisers}
              validate={advertiserValidation}
            />
            <div className="form-group__col-flex-column">
              <div className="edit-campaign__submit">
                <button className="btn btn-primary" type="submit">
                  Assign
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default P3TemplateAssign;
